import { render, staticRenderFns } from "./EditShift.vue?vue&type=template&id=4d4424cb&"
import script from "./EditShift.vue?vue&type=script&lang=js&"
export * from "./EditShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports